import React, { useEffect } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Dialog, DialogContent, DialogTitle, DialogActions, Typography, Divider } from '@material-ui/core'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import SplitGoodsFormProperties from './SplitGoodsFormProperties'
import SplitGoodsMakeValidationSchema from './SplitGoodsMakeValidationSchema'

const {
  button: { CngButton }
} = components

function SplitGoodsDialog(props) {
  const { splitGoods, isView, onAddSplitGoods, onEditSplitGoods, open, onClose, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.TITLE)
  const saveButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.SAVE_BUTTON)

  const validationSchema = SplitGoodsMakeValidationSchema(translate)

  const methods = useForm({
    defaultValues: SplitGoodsFormProperties.formikProps.initialValues,
    resolver: yupResolver(validationSchema)
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    if (open) {
      if (splitGoods) {
        reset(splitGoods)
      } else {
        reset(SplitGoodsFormProperties.formikProps.initialValues)
      }
    }
  }, [open, splitGoods])

  function onSubmit(data) {
    if (splitGoods) {
      onEditSplitGoods(data)
    } else {
      onAddSplitGoods(data)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h5"><strong>{title}</strong></Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <SplitGoodsFormProperties.Fields disabled={isView} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <CngButton color="secondary" onClick={onClose} size="medium">Cancel</CngButton>
        {!isView && (
          <CngButton color="primary" onClick={handleSubmit(onSubmit)} size="medium">
            {splitGoods ? 'Update' : saveButton}
          </CngButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default SplitGoodsDialog
